// extracted by mini-css-extract-plugin
export default {"wrapper":"DropDownCourse_wrapper__q+g2E","icon":"DropDownCourse_icon__jdEWm"};